import { get,post } from "../utils/https.js"
const api = {
  banner: '/api/index/getBannerList',
  notice:'/api/Index/getNoticeList',
  hotProduct:'/api/index/getHotProduct',//热门回收
	getIndexNotice:'/api/Index/getIndexNotice',//首页弹出公告
	issue:'/api/my/getProblem',//常见问题
	connection:"/api/my/getContactUs",//联系我们
	getCardList: '/api/category.card_category/getCardList',//卡券分类展示
	getGoodsList: '/api/goods.goods/getGoodsList',//卡券分类详情
	list: '/api/category.category/getCategoryList',//卡券分类展示
	check_token:"/api/login/chToken",//判断token是否失效
	login: '/index.php?s=/api/login/phonePassLogin',//登录
	register:'/api/login/phoneRegister',//注册
	login_phone:'/api/Login/phoneLogin',//验证码登陆
	userInfo: '/api/user/getUserInfo',//获取用户信息
	sendSmsCaptcha: '/index.php?s=/api/message.Phone_message/sendMessage',//手机号登陆验证码
	sendMessageRegister:'/api/message.Phone_message/sendMessageRegister',//注册验证码
	getAppid:'/api/my/getAppid',//获取APPid
	submitFeedback:"/api/feed_back/index", //意见返款
	getWithdrawNotice:'/api/settings/getWithdrawNotice',//提现备注
	getUserRealStatus:'/api/user/getUserRealStatus',//获取实名信息
	getWithdrawType:'/api/user/getWithdrawType',//提现方式
	getWithdrawList:"/api/user/getWithdrawList",//提现列表
	withdrawPrice:"/api/user/withdrawPrice", //余额提现
	setWithdrawBank:"/api/user/setWithdrawBank",//添加银行卡
	setWithdrawAli:"/api/user/setWithdrawAli",//添加支付宝
	getWithdrawAppId:"/api/user/getWithdrawAppId",//添加微信账号二维码
	getJsonQrcode:'/api/index/getJsonQrcode',//获取二维码
	upWithdrawAli:'/api/user/upWithdrawAli',//修改支付宝账号
	upWithdrawBank:'/api/user/upWithdrawBank',//修改银行卡号
	delWithdrawAli:"/api/user/delWithdrawAli",//删除支付宝账号
	delWithdrawWx:"/api/user/delWithdrawWx",//删除微信账户
	delWithdrawBank:"/api/user/delWithdrawBank",//删除银行卡
	orderList:'/api/order/getOrderList',//订单列表
	WithdrawList:'/api/withdraw/getWithdrawList',//提现记录
	bindPhone:'/api/settings/bind',//第一次绑定手机号
	upPass:'/api/settings/upPassword',//修改密码
	updatePhone:'/api/settings/bindPhone',//修改绑定手机
	passCode:'/api/message.Phone_message/newPhoneMessage',//修改密码验证码
	bindPhoneCode:'/api/message.Phone_message/sendBindMobileMessage',//第一次绑定手机验证码
	updatePhoneCode:'/api/message.Phone_message/sendBindMessage',//换绑手机验证码
	realUser:"/api/user/realUser",//初级实名
	aliAuthentication: '/api/user/aliAuthentication', //支付宝实名认证
	wxAuthentication: '/api/user/wxAuthentication', //微信实名认证
	postOrder:'/index.php?s=/api/order/buyCart',//单卡提交
	batchPostOrder:'/index.php?s=/api/order/batchBuyCart',//批量提交
  getWithdrawAppIdForKf:'/api/user/getWithdrawAppIdForKf',//pc端获取appid
	wxLogin:'/api/login/index',//登录
	searchDetail: '/index.php?s=/api/goods.goods/getGoodsList',//搜索
	getBalanceLog:"/api/Statistics/getBalanceLog",//资金明细
  systemsettings:'/api/my/systemsettings',//平台设置
  carouselchart:'/api/user/carouselchart',//首页轮播图
  getContent:'/api/Content/getContent',//协议接口
  noticepc:'/api/content/platformindex',//平台公告

  settlementsubmit:'/api/Survey/settlementSubmit',//提交结算数据
  approvalStatus:'/api/Survey/approvalStatus',//查看结算状态
  duediligence:'/api/Survey/dueDiligence',//尽职调查
  dueDiligenceStatus:'/api/Survey/dueDiligenceStatus',//查看尽职调查状态
  surveyList:'/api/Survey/surveyList',//快速结算问题列表
  surveydesc:'/api/Survey/surveydesc',//快结算问题详情
  surveysubmitl:'/api/Survey/surveysubmit',//提交问题

  articleHotpc:'/index/api.article/hotpc',//热门资讯
  categorypc:'/index/api.article/categorypc',//文章分类
  news_api:'/index/api.article/news_api',//资讯列表
  agreementpc:'/index/api.article/agreementpc',
  StatisticsRecord:'/api/Statistics/StatisticsRecord',//销卡统计
}
//热门回收
export const apiAddress = param => post(api.hotProduct, param);
// 首页公告
export const getIndexNotice = param => get(api.getIndexNotice, param);
// 常见问题
export const issue = param => get(api.issue, param);
// 联系我们
export const connection = param => get(api.connection, param);
// 卡券分类展示
export const getCardList = param => get(api.getCardList, param);
// 卡券详情展示
export const getGoodsList = param => get(api.getGoodsList, param);
// 首页卡券分类展示
export const list = param => get(api.list, param);
// 判断token是否失效
export const check_token = param => get(api.check_token, param);
// 登录
export const login = param => post(api.login, param);
// 注册
export const register = param => post(api.register, param);
// 验证码登陆
export const login_phone = param => post(api.login_phone, param);
// 获取用户信息
export const userInfo = param => get(api.userInfo, param);
// 手机号登陆验证码
export const sendSmsCaptcha = param => get(api.sendSmsCaptcha, param);
///微信appid获取
export const getAppid = param => get(api.getAppid, param);
// 注册验证码
export const sendMessageRegister = param => get(api.sendMessageRegister, param);
// 意见反馈
export const submitFeedback = param => post(api.submitFeedback, param);
//提现备注
export const getWithdrawNotice = param => post(api.getWithdrawNotice, param);
//实名信息
export const getUserRealStatus = param => post(api.getUserRealStatus, param);
//开通什么提现方式
export const getWithdrawType = param => post(api.getWithdrawType, param);
//提现账号
export const getWithdrawList = param => post(api.getWithdrawList, param);
//开通什么提现方式
export const withdrawPrice = param => post(api.withdrawPrice, param);
// 添加支付宝
export const setWithdrawAli = param => post(api.setWithdrawAli, param);
// 添加银行卡
export const setWithdrawBank = param => post(api.setWithdrawBank, param);
// 绑定微信提现获取appid接口
export const getWithdrawAppId = param => post(api.getWithdrawAppId, param);
// 获取绑定微信的二维码
export const getJsonQrcode = param => post(api.getJsonQrcode, param);
// 修改银行卡
export const upWithdrawBank = param => post(api.upWithdrawBank, param);
// 修改支付宝
export const upWithdrawAli = param => post(api.upWithdrawAli, param);
// 删除支付宝
export const delWithdrawAli = param => post(api.delWithdrawAli, param);
// 删除银行卡
export const delWithdrawBank = param => post(api.delWithdrawBank, param);
// 删除微信
export const delWithdrawWx = param => post(api.delWithdrawWx, param);
// 订单列表
export const orderList = param => get(api.orderList, param);
//提现记录
export const WithdrawList = param => get(api.WithdrawList, param);
//第一次绑定手机号
export const bindPhone = param => post()(api.bindPhone, param);
//修改登录密码
export const upPass = param => post(api.upPass, param);
//修改手机验
export const updatePhone = param => post(api.updatePhone, param);
//修改密码验证码
export const passCode = param => get(api.passCode, param);
//首次绑定手机验证码
export const bindPhoneCode = param => get(api.bindPhoneCode, param);
//修改手机验证码
export const updatePhoneCode = param => post(api.updatePhoneCode, param);
//初级实名
export const realUser = param => post(api.realUser, param);
//支付宝高级实名
export const aliAuthentication = param => post(api.aliAuthentication, param);
//微信高级实名
export const wxAuthentication = param => post(api.wxAuthentication, param);
//单卡提交
export const postOrder = param => post(api.postOrder, param);
//批量提交
export const batchPostOrder = param => post(api.batchPostOrder, param);
//获取pc端微信登录appid wxLogin
export const getWithdrawAppIdForKf = param => post(api.getWithdrawAppIdForKf, param);
//批量提交
export const wxLogin = param => post(api.wxLogin, param);
//搜索
export const searchDetail = param => post(api.searchDetail, param);
//资金明细
export const getBalanceLog = param => post(api.getBalanceLog, param);
//平台设置
export const systemsettings = param => get(api.systemsettings, param);
//首页轮播图
export const carouselchart = param => get(api.carouselchart, param);
//协议
export const getContent = param => get(api.getContent, param);
//协议
export const noticepc = param => get(api.noticepc, param);
export const approvalStatus = param => get(api.approvalStatus, param);
export const dueDiligenceStatus = param => get(api.dueDiligenceStatus, param);
export const settlementsubmit = param => post(api.settlementsubmit, param);
export const duediligence = param => post(api.duediligence, param);
export const surveyList = param => get(api.surveyList, param);
export const surveydesc = param => get(api.surveydesc, param);
export const surveysubmitl = param => post(api.surveysubmitl, param);


export const articleHotpc = param => get(api.articleHotpc, param);
export const categorypc = param => get(api.categorypc, param);
export const news_api = param => get(api.news_api, param);
export const agreementpc = param => get(api.agreementpc, param);

export const StatisticsRecord = param => get(api.StatisticsRecord, param);



// WEBPACK FOOTER //
// ./src/api/index.js